import React, { useState } from "react";
import { Input } from "../v3/themed/Input";
import { parsePhoneNumber } from "libphonenumber-js";

export const formatPhoneNumber = (input: string, countryCode: string) => {
    try {
        const fullNumber = input.startsWith("+")
            ? input
            : `+${countryCode}${input}`;
        const number = parsePhoneNumber(fullNumber);

        if (number.isValid()) {
            const formatted = number.formatInternational();
            return formatted.replace(`+${countryCode} `, "");
        } else {
            return input;
        }
    } catch (e) {
        return input;
    }
};

export const unformatPhoneNumber = (input: string) => {
    return input.replace(/\D/g, "");
};

type PhoneNumberInputProps = {
    phoneNumber: string;
    setPhoneNumber: (phoneNumber: string) => void;
    countryCode: string;
};

const PhoneNumberInput = (props: PhoneNumberInputProps) => {
    const [phone, setPhone] = useState("");
    const [formattedPhone, setFormattedPhone] = useState(
        formatPhoneNumber(props.phoneNumber, props.countryCode),
    );

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        setFormattedPhone(formatPhoneNumber(value, props.countryCode));
        setPhone(unformatPhoneNumber(value));
        props.setPhoneNumber(unformatPhoneNumber(value));
    };

    return (
        <Input
            value={formattedPhone.trim() !== "" ? formattedPhone : phone}
            onChange={handleInputChange}
            placeholder={`XXXXXXXXXX`}
        />
    );
};

export default PhoneNumberInput;
